<template>

  <section>
    <div class="container">
      <div class="detail" style="max-width: 740px;margin-left: auto;margin-right: auto;">
        <QrDetail variant="modal" />
        <div class="detail-t">
          <h1>{{info.title}}</h1>
          <div class="p-info">
            <span>时间：<span>{{info.createtime}}</span> </span>
            <a href="javascript:;" class="p-name">杏坛艺拍</a>
          </div>

        </div>

        <div class="detail-c" v-html="info.Detailcontent">

        </div>

        <div class="detail-f">
          <div class="comment-box">
            <div class="comment-box-t">
              <div class="comment">
                <a href="javascript:;" class="comment-item comment-heart"> <i id="likecount">0</i></a>
                <a href="javascript:;" class="comment-item"> <i>0</i></a>
              </div>
              <a href="javascript:;" class="right">我要评论</a>
            </div>
            <div class="comment-box-c">
              <div class="comment-list">
                <div class="nocomment">暂无评论</div>
                <div class="comment-con">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style lang="scss" scoped>
.detail .detail-t h1 {
  text-align: center;

}

.detail .detail-t .p-info {
  text-align: center;
  color: #999999;
  font-size: 16px;
  position: relative;
}

.detail .detail-t .p-info .p-name {
  color: #cfa972;
  margin-left: 30px;
  text-decoration: none;
}

.detail .detail-t .p-info::before,
.detail .detail-t .p-info::after {
  content: "";
  display: block;
  width: 30%;
  height: 0;
  border-bottom: 1px dashed #999999;
  position: absolute;
  top: 10px;
}

.detail .detail-t .p-info::before {
  left: 0;
}

.detail .detail-t .p-info::after {
  right: 0;
}

.detail .detail-c {
  padding: 20px 15px;
}

.comment-box {
  padding: 20px 0;
}

.comment-box .comment-box-t {
  margin-top: 10px;
  font-size: 14px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  padding: 20px 0;
  border-bottom: 2px solid #d7d7d7;
}

.comment-box .comment-box-t .right {
  text-decoration: none;
  color: #cfa972;
}

.detail .nocomment {
  text-align: center;
  font-size: 13px;
  height: 6em;
  line-height: 6em;
  display: none;
}

.comment-list .item {
  padding: 22px 20px 22px 15px;
  border-top: 1px solid #f4f4f4;
}

.comment-list .item:nth-child(1) {
  border-top: none;
}

.comment-list .item .avatar {
  display: inline-block;
  width: 90px;
  height: 90px;
  margin-right: 17px;
  border-radius: 45px;
  vertical-align: top;
}

.comment-list .item .content {
  display: inline-block;
  font-size: 14px;
  vertical-align: top;
  line-height: 25px;
  color: #313334;
  margin-top: 20px;
  width: calc(100% - 120px);
}

.comment-list .item .content .name {
  color: #cfa972;
}

.comment-list .item .content .msg {
  font-size: 13px;
  white-space: pre-wrap;
}

.comment .comment-item {
  display: inline-block;
  position: relative;
  width: 72px;
  padding-left: 30px;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  background-image: url(../../assets/image/comment.png);
  background-repeat: no-repeat;
  color: #adadad;
  cursor: pointer;
  text-decoration: none;
}

.comment .comment-heart-up {
  background-image: url(../../assets/image/praise.png);
}

.comment .comment-item i {
  font-style: normal;
}

.comment a:nth-child(2) {
  background-image: url(../../assets/image/praise.png);
}
</style>
<script>
import {
  News
} from "../../model/news.js";
import QrDetail from '../../components/qrdetail.vue';
let news = new News();
export default {
  name: 'index',
  data() {
    return {
      id: this.$route.query.id,
      info:{}
    }
  },
  components: {
    QrDetail
  },
  methods: {
    getInfomationDetail() {
      let _this = this;
      return new Promise(function (resolve, reject) {
        news.infomationDetail({
          UnionId: "123",
          InfoId: _this.id
        }).then((res) => {
         _this.info = res;
          resolve()
        }, () => {
          reject()
        })
      })
    }
  },
  created() {
    this.getInfomationDetail();
  }
}
</script>
